import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { serializer } from "@/api/shared/serializer";
import moment from "moment";
import { batchUpdate } from "@/utils/batchUpdate";
import { CommentSenderRoleEnum } from "@/enums/CommentSenderRoleEnum";

const commentsModule: Module<any, any> = {
  namespaced: false,
  state: {
  },

  mutations: {
  },

  actions: {
    async getCommentsByServiceRequestId({ commit }, serviceRequestId) {
      const snap = await firebase.firestore().collection("comments")
        .where('facilityId', '==', this.state.authModule.currentFacility)
        .where('serviceRequestId', '==', serviceRequestId)
        .orderBy("createdAt", "asc")
        .get()

      let comments = serializer.querySnapshotToDocuments<any>(snap)

      comments = comments.sort((a: any, b: any) => moment(a.createdAt).diff(moment(b.createdAt)));

      return comments
    },

    async resetServiceRequestCommentsCount({ commit }, serviceRequestId) {
      const snap = await firebase.firestore().collection("serviceRequests").doc(serviceRequestId).get()
        
      if(snap.exists){
        await snap.ref.update({staffUnreadCommentsCount: 0})
      }
    },

    async addComment({ dispatch }, data) {

      if (!data || !data.receiverId) return

      try {

        data.facilityId = this.state.authModule.currentFacility
        data.createdAt = new Date()

        const res = await firebase.firestore().collection("comments").add(data)

        data.id = res.id

        return data

      } catch (error) {
        console.error(error)
        return null
      }

    },

    async updatecomment({ dispatch }, data) {

      if (!data.id) return

      const updateData = {
        dateTimeUpdated: firebase.firestore.Timestamp.fromDate(new Date()),
        message: data.message
      }

      return await firebase.firestore().collection("comments").doc(data.id).update(updateData)
        .catch((error) => {
          console.error("Error updating comments", error);
        })
    },

    async deleteComment({ dispatch }, id) {
      if (id?.length <= 0) return;

      try {
        await firebase.firestore().collection("comments").doc(id).delete();
      } catch (error) {
        console.error("Error deleting ad hoc activities", error);
      }
    },

    async readIncomingComments({ commit }, serviceRequestId) {

      try {
        const snap = await firebase.firestore().collection("comments")
          .where('facilityId', '==', this.state.authModule.currentFacility)
          .where('read', '==', false)
          .where('serviceRequestId', '==', serviceRequestId).get()

        const comments = serializer.querySnapshotToDocuments<any>(snap)
        
        const itemsToUpdate = comments.map(n => {
          const itemToUpdate = { docId: n.id, updates: { read: true, readDateTime: new Date() } }
          return itemToUpdate
        })

        const result = await batchUpdate('comments', itemsToUpdate)
        console.log('read comments result: ', result)
        if (result.status === 200) return true
        else return false
      }
      catch (error) {
        return false
      }

    },
    async readIncomingComment({ commit }, commentId) {
      try {
        const snap = await firebase.firestore().collection("comments").doc(commentId).get()

        if(snap.data().senderRole === CommentSenderRoleEnum.Staff){
          return false
        }

        snap.ref.update({ read: true, readDateTime: moment().toISOString()})
        return true
      }
      catch (error) {
        return false
      }

    },
  }
};
export default commentsModule;